import { all, fork } from "redux-saga/effects";
import { assignPageSaga } from "../pages/assign/assign-page.saga";
import { loginPageSagas } from "../pages/login/login-page.saga";
import { appSagas } from "./app.saag";
import { assignsSagas } from "./assigns.saga";
import { employeesSagas } from "./employees.saga";
import { groupsSagas } from "./groups.saga";
import { jobsSagas } from "./jobs.saga";
import { systemSagas } from "./system.saga";
import { uiSaga } from "./ui.saga";

export const rootSaga = function*() {
  yield all([
    yield fork(systemSagas),
    /* Domain */
    yield fork(groupsSagas),
    yield fork(employeesSagas),
    yield fork(jobsSagas),
    yield fork(assignsSagas),
    /* app */
    yield fork(appSagas),
    /* Page */
    yield fork(loginPageSagas),
    yield fork(assignPageSaga),
    /* UI */
    yield fork(uiSaga)
  ]);
};
